// VIDEO LAZYLOAD
document.addEventListener("DOMContentLoaded", function () {
  var lazyVideos = [].slice.call(document.querySelectorAll("video.lazy"));

  if ("IntersectionObserver" in window) {
    var lazyVideoObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (video) {
        if (video.isIntersecting) {
          for (var source in video.target.children) {
            var videoSource = video.target.children[source];
            if (
              typeof videoSource.tagName === "string" &&
              videoSource.tagName === "SOURCE"
            ) {
              videoSource.src = videoSource.dataset.src;
            }
          }

          video.target.load();
          video.target.classList.remove("lazy");
          lazyVideoObserver.unobserve(video.target);
        }
      });
    });

    lazyVideos.forEach(function (lazyVideo) {
      lazyVideoObserver.observe(lazyVideo);
    });
  }


  const productQtyInputs = () =>
    document.querySelectorAll(".productView-quantity .quantity__input");

  // A Yampi desabilita os botoes [name="add"] enquanto consulta o status da loja
  // e o quantity-input do tema copia esse estado (variants.js/checkVariantInventory).
  // Como a Yampi so reabilita o botao, a quantidade continuava disabled: campos
  // disabled nao entram no serialize do form, entao o /cart/add.js ia sem
  // "quantity" e o carrinho sempre recebia 1 item.
  const syncQuantityAvailability = () => {
    const addButton = document.getElementById("product-add-to-cart");
    if (!addButton) return;

    productQtyInputs().forEach((input) => {
      input.disabled = addButton.disabled;
      input
        .closest("quantity-input")
        ?.querySelectorAll(".btn-quantity")
        .forEach((button) => {
          button.disabled = addButton.disabled;
        });
    });
  };

  const addToCartButton = document.getElementById("product-add-to-cart");
  if (addToCartButton) {
    syncQuantityAvailability();
    new MutationObserver(syncQuantityAvailability).observe(addToCartButton, {
      attributes: true,
      attributeFilter: ["disabled"],
    });
  }

  const progressiveOfferRadios = document.querySelectorAll(
    'input[name="progressive-offer"]'
  );
  progressiveOfferRadios.forEach((radio) => {
    radio.addEventListener("change", function (e) {
      if (radio.checked) {
        // Replica em todos os seletores de quantidade (principal, oculto e sticky)
        productQtyInputs().forEach((input) => {
          input.value = radio.value;
        });

        const mainQtInput = document.querySelector(
          ".quantity__group--1 .quantity__input"
        );
        // Avisa o tema para recalcular subtotal, preco sticky e regras de estoque
        mainQtInput?.dispatchEvent(new Event("change", { bubbles: true }));
      }
    });
  });
});
